(function () {
  'use strict';

  angular
    .module('app.account-create', [])

    /* @ngInject */
    .controller('accountCreateCtrl', ["$scope", "$rootScope", "$timeout", "$location", "HttpService", "AppService", "LogService", "RoutesService", function ($scope, $rootScope, $timeout, $location, HttpService, AppService, LogService, RoutesService) {
      var unwatch;

      $scope.formData = {
        RememberMe: false,
        CustomerPro: false,
        errors: [],
        returnUrl: '/Account',
        Address: ' ',
        AddressApartment: ' ',
        AddressBuilding: ' ',
        AddressLocality: ' ',
        Phone: ' ',
        MobilePhone: ' '
      };

      $timeout(function () {
        $scope.formData.Address = '';
        $scope.formData.AddressApartment = '';
        $scope.formData.AddressBuilding = '';
        $scope.formData.AddressLocality = '';
        $scope.formData.Phone = '';
        $scope.formData.MobilePhone = '';
      }, 0);

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function () {

        $scope.formData.ConfirmEmail = $scope.formData.Email;

        $scope.$emit('showPageLoader', true);

        HttpService.post({
          url: '/AccountCreate',
          data: $scope.formData
        })
        .then(function (response) {
          AppService.getTranslate()
          .then(function (translate) {
            if (response.status === 'OK') {
              $rootScope.$broadcast('login');
              if (LogService.redirect) {
                if (LogService.redirect.url) $location.path(LogService.redirect.url).replace();
                if (LogService.redirect.action) LogService.redirect.action();
                LogService.redirect = null;
              } else {
                $location.path('/' + RoutesService.get().AccountHome.url).replace();
              }
            } else {
              _.each(response.errors, function (error, key) {
                if (key === 'Global') {
                  $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                }
              });
              $scope.$emit('showPageLoader', false);
            }
          })
          .catch(function (error) {
            console.error(error);
          });
        })
        .catch(function (error) {
          console.error(error);
        });

      };

      $scope.$on('$destroy', function () {
        if (typeof unwatch !== 'undefined') {
          unwatch();
        }
      });

      unwatch = $scope.$watch('formData.CustomerPro', function (value) {
        if (!value) {
          $scope.formData.IDCompanyTitle = '';
          $scope.formData.Company = '';
          $scope.formData.Siret = '';
          $scope.formData.IDActivity = '';
          $scope.formData.IDActivityDomain = '';
          $('#IDCompanyTitle').selectpicker('val', '');
        }
        $timeout(function () {
          $scope.form.$resetValidation();
        });
      });

      $scope.toggleCustomerPro = function (event) {
        if (event.which === 13) {
          event.preventDefault();
          $scope.formData.CustomerPro = !$scope.formData.CustomerPro;
        }
      };

    }]);

})();
